import React, { useEffect, useState } from 'react'
import CollapsibleCard from 'Components/collapsibleCard'
import DynamicTable from 'Components/dynamicTable'
import Proxies from '../../components/proxies'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Form, Button, Input } from 'reactstrap'
import FormField from 'Components/formField'
import moment from 'moment'
import { Box } from '@material-ui/core'

const taxInfoHeaders = {
  UserID: 'User ID',
  userUID: 'User UID',
  userName: 'User Name',
  BrandID: 'Brand ID',
  month: 'Month',
  points: 'Points',
  computedPrice: 'Currency'
}

const taxCorrectionsHeaders = {
  UserID: 'User ID',
  amountCurrency: 'Amount Currency',
  currency: 'Currency'
}

const MonthlyTaxInfoNoActivation = () => {
  const [userTaxInfo, setUserTaxInfo] = useState([])
  const [brandsLoading, setBrandsLoading] = useState(true)
  const [taxInfoLoading, setTaxInfoLoading] = useState(false)
  const [BrandID, setBrandID] = useState(null)
  const [brands, setBrands] = useState([])
  const [error, setError] = useState(null)
  const [taxCorrections, setTaxCorrections] = useState([])
  const [selectedYear, setSelectedYear] = useState(2026)
  const [selectedMonth, setSelectedMonth] = useState(
    moment()
      .subtract(1, 'months')
      .month() + 1
  )

  function fetchEarningsTaxReport() {
    setTaxInfoLoading(true)
    Proxies.GET('payments/getTaxInfo', { BrandID, year: selectedYear, month: selectedMonth }).then(response => {
      if (response.error) {
        setError(response.error.message)
      } else {
        setError(null)
        setUserTaxInfo(response)
      }
      setTaxInfoLoading(false)
    })
  }

  function fetchUnappliedTaxCorrections() {
    Proxies.GET('payments/getUnappliedTaxCorrections', { BrandID }).then(response => {
      if (response.error) {
        setError(response.error.message)
      } else {
        setError(null)
        setTaxCorrections(response)
      }
    })
  }

  function onSearch() {
    fetchUnappliedTaxCorrections()
    fetchEarningsTaxReport()
  }

  function onApplyCorrections() {
    setTaxInfoLoading(true)
    Proxies.POST('payments/applyTaxCorrections', { BrandID: Number(BrandID), year: selectedYear, month: selectedMonth }).then(response => {
      if (response.error) {
        setError(response.error.message)
      } else {
        setError(null)
        onSearch()
      }
    })
    setTaxInfoLoading(false)
  }

  useEffect(() => {
    setBrandsLoading(true)
    Proxies.GET('menus/listBrands').then(responseJSON => {
      setBrands(responseJSON)
      setBrandsLoading(false)
    })
  }, [])

  if (brandsLoading) {
    return <FontAwesomeIcon icon='spinner' spin />
  }

  return (
    <React.Fragment>
      <CollapsibleCard header={<strong>Monthly tax info</strong>} startOpen={true}>
        <Form
          onSubmit={e => {
            e.preventDefault()
          }}
        >
          <FormField field={'BrandID'} name='Brand'>
            <Input
              type='select'
              name='BrandID'
              value={BrandID}
              onChange={e => {
                setBrandID(e.target.value)
              }}
            >
              <option selected='true' disabled={true} value={''}>
                Select Brand
              </option>
              {brands &&
                !!brands.length &&
                brands.map(e => {
                  return (
                    <option value={e.BrandID} key={e.BrandID}>
                      {e.BrandID} - {e.brandName}
                    </option>
                  )
                })}
            </Input>
          </FormField>
          <FormField field={'selectedYear'} name='Year'>
            <Input
              type='select'
              name='selectedYear'
              value={selectedYear}
              onChange={e => {
                setSelectedYear(Number(e.target.value))
              }}
            >
              <option selected='true' disabled={true} value={''}>
                Select Year
              </option>
              {[2021, 2022, 2023, 2024, 2025, 2026].map(e => {
                return (
                  <option value={e} key={e}>
                    {e}
                  </option>
                )
              })}
            </Input>
          </FormField>
          <FormField field={'selectedMonth'} name='Month'>
            <Input
              type='select'
              name='selectedMonth'
              value={selectedMonth}
              onChange={e => {
                setSelectedMonth(Number(e.target.value))
              }}
            >
              <option selected='true' disabled={true} value={''}>
                Select Month
              </option>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(e => {
                return (
                  <option value={e} key={e}>
                    {e}
                  </option>
                )
              })}
            </Input>
          </FormField>
        </Form>
        <div style={{ flexDirection: 'row', marginBottom: 32, paddingHorizontal: 16 }}>
          <Button disabled={!BrandID} style={{ marginRight: 16 }} onClick={() => onSearch()}>
            Search
          </Button>
        </div>

        {taxInfoLoading ? (
          <FontAwesomeIcon icon='spinner' spin />
        ) : (
          <Box display={'flex'} flexDirection={'column'} gridGap={32}>
            {error ? <p>{error}</p> : null}

            {!!taxCorrections?.length && (
              <Box display={'flex'} flexDirection={'column'} gridGap={16}>
                <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                  <strong>Tax corrections</strong>
                  <Button disabled={!BrandID} style={{ marginRight: 16 }} onClick={() => onApplyCorrections()}>
                    Apply corrections to selected month
                  </Button>
                </Box>
                <DynamicTable
                  data={taxCorrections}
                  headers={taxCorrectionsHeaders}
                  options={{
                    fieldFunctions: {
                      amountCurrency: e => {
                        return e.amountCurrency.toFixed(2)
                      }
                    }
                  }}
                />
              </Box>
            )}

            {userTaxInfo && !userTaxInfo.length ? <p>No Orders in the selected time.</p> : null}

            {!!userTaxInfo?.length && (
              <Box display={'flex'} flexDirection={'column'} gridGap={16}>
                <strong>Tax info</strong>
                <DynamicTable
                  data={userTaxInfo}
                  headers={taxInfoHeaders}
                  options={{
                    fieldFunctions: {
                      points: e => {
                        return e.points.toFixed()
                      },
                      computedPrice: e => {
                        return e.computedPrice.toFixed(2)
                      }
                    }
                  }}
                />
              </Box>
            )}
          </Box>
        )}
      </CollapsibleCard>
    </React.Fragment>
  )
}

export default MonthlyTaxInfoNoActivation
